export const loginUrls = [
  '/web/login',
  '/web/sign_up',
  '/web/forgot_password/email',
  '/web/forgot_password/code',
  '/web/forgot_password/new_password',
  '/web/select_mezzo_device_connection',
]
